import * as React from 'react';
// @ts-expect-error
import {components} from 'react-select';
// @ts-expect-error
import type {MenuListComponentProps} from 'react-select';

import {CogIcon} from '../icon/svg/cog-icon';
import {StackLegacy} from '../layout/stack/stack-legacy';

import type {FooterButtonProps} from './select-picker-generic';

import styles from './custom-menu-list.module.css';

// We need to set a min-height on the menu list to prevent it from collapsing if there are only a few options, so that the footer button stays at the bottom
const MENU_LIST_STYLES = {
    overflowY: 'auto',
} as const;

export const getCustomMenuList =
    (footerButton?: FooterButtonProps) =>
    ({children, ...props}: MenuListComponentProps) => {
        const Icon = (footerButton && footerButton.icon) || CogIcon;

        return (
            <>
                <components.MenuList {...props}>
                    {footerButton ? <div style={MENU_LIST_STYLES}>{children}</div> : children}
                </components.MenuList>
                {footerButton && (
                    <div onClick={footerButton.onClick} className={styles['fixed-footer']}>
                        <StackLegacy spacing={8} isHorizontal={true} alignCenter={true}>
                            <Icon size={13} alignCenter={true} />
                            <div>{footerButton.label}</div>
                        </StackLegacy>
                    </div>
                )}
            </>
        );
    };
